<template>
  <v-app>
    <AppWrapperView>
      <v-main>
        <v-container class="pa-8" fluid>
          <v-row>
            <v-col cols="12">
              <v-alert v-model="alertSuccessFlg" type="success" density="compact" :title=successMsg closable
                class="ma-2" />
              <v-alert v-model="alertErrorFlg" type="error" density="compact" :title=errorMsg closable class="ma-2" />
            </v-col>
          </v-row>
          <v-row v-for="uploadType in uploadTypes" :key=uploadType>
            <v-col cols="6">
              {{ $t(`cooperationFileUpload.label.${uploadType}`) }}
              <v-btn dark class="ml-4 bg-indigo-darken-1" :disabled="isLoading" elevation="2" :loading="isLoading"
                @click="onUpdateBtnClick(uploadType)">
                {{ $t('common.action.upload') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <input ref="updateBtn" type="file" accept=".csv,.dat" style="display: none" @change="selectedFile" />
        <ConfirmDialog v-if="confirmDialogVisible" :dialog-data="confirmDialog" :handle-ok="upload"
          :handle-cancel="closeConfirmDialog" />
      </v-main>
    </AppWrapperView>
  </v-app>
</template>
<script lang="js">
import AppWrapperView from "@/components/views/AppWrapperView";
import api from "@/apis/staff";
import ConfirmDialog from "@/components/dialog/ConfirmDialog";

export default {
  components: { AppWrapperView, ConfirmDialog },
  props: {},
  data: () => ({
    // 確認ダイアログ
    confirmDialogVisible: false,
    confirmDialog: {
      message: null,
    },
    // アップロード情報
    uploadType: null,
    uploadFile: null,
    // メッセージ関連
    alertSuccessFlg: false,
    alertErrorFlg: false,
    successMsg: "",
    errorMsg: "",
    isLoading: false,
  }),
  computed: {
    // アップロード可能な連携ファイル種別
    // 会社ごとに提供範囲が異なるため setting/table/<company>.json で切り替える
    uploadTypes() {
      return this.$getTableDef("CooperationFileUploadPage");
    },
  },
  methods: {
    // アップロードボタン押下
    onUpdateBtnClick(type) {
      this.resetMsg();
      this.uploadType = type;
      this.$refs.updateBtn.value = null;
      this.$refs.updateBtn.click();
    },
    // ファイル選択後に確認ダイアログを表示
    selectedFile() {
      this.uploadFile = this.$refs.updateBtn.files[0];

      const fileName = this.uploadFile.name;
      const typeName = this.$t(`cooperationFileUpload.label.${this.uploadType}`);
      const message = this.$t(`cooperationFileUpload.message.confirm`, [typeName, fileName]);

      this.confirmDialog.message = message;
      this.confirmDialogVisible = true;
    },
    // ダイアログ非表示
    closeConfirmDialog() {
      this.confirmDialogVisible = false;
      this.confirmDialog.file = null;
    },
    // メッセージ初期化
    resetMsg() {
      this.alertSuccessFlg = false;
      this.alertErrorFlg = false;
      this.successMsg = "";
      this.errorMsg = "";
    },
    // アップロード
    upload() {
      this.isLoading = true;
      this.resetMsg();
      this.closeConfirmDialog();

      let formData = new FormData();
      formData.append("file", this.uploadFile);
      formData.append("uploadType", this.uploadType);

      api.postFile("/cooperation-file/upload", formData)
        .then((response) => {
          if (response.data?.status == 0) {
            this.successMsg = this.$t('cooperationFileUpload.message.complete');
            this.alertSuccessFlg = true;
          } else {
            this.errorMsg = response.data?.errorMessage;
            this.alertErrorFlg = true;
          }
        })
        .catch(() => {
          this.errorMsg = this.$t('common.message.unknownError');
          this.alertErrorFlg = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
